import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { EquipFieldData } from './EquipFieldData';
/*
 * hidden - dispatchEquipmentXrefId
 * hidden - dispatchId
 * (checkbox)
 *Equipment Id: systemId
 * Manufacturer: manufacturerName manufacturerId
 * Model : model
 * (Additional Details - button)
 * Serial #: serialNumber
 * Type: manufacturerTypeName manufacturerTypeId
 * Barcode: barcode 
 * Notes: notes
 * Created By: createdBy
 * Date Created: creationDate;
 * (View Inventory Items Used - button)
 */
export class v_DispatchEquipmentSvcdBus extends BaseBus
{
    constructor(busObj: v_DispatchEquipmentSvcdBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.creationDate = DateFunctions.getDate(this.creationDate);
        this.equipFieldData = new EquipFieldData(this.equipFieldData);

    }
    CID(): any {
        return this.equipmentId;
        //return this.dispatchEquipmentXrefId;
    }
    setId(id: any) {
        this.dispatchEquipmentXrefId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.insertDt = date;
        this.locationId = other.locationId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    dispatchEquipmentXrefId: any;
    isOnDispatchQuote: boolean;
  dispatchId: any;
  equipmentId: any;
  manufacturerId: any;
  manufacturerTypeId: any;
  model: String;
  serialNumber: String;
  notes: String;
  manufacturerName: String;
  manufacturerTypeName: String;
  locationId: any;
  systemId: String;
  barcode: String;
  col1Data: String;
  col2Data: String;
  col3Data: String;
  col4Data: String;
  col5Data: String;
  col6Data: String;
  col7Data: String;
  col8Data: String;
  col9Data: String;
  col10Data: String;
  equipImg: String;
  equipDocUrl: String;
  countSerialParts: number;
  createdBy: String;
  creationDate: Date;
  insertUserId: any;
  insertDt: Date;
  updateUserId: any;
    updateDt: Date;
    dummy: any;
    originalIsOnDispatchQuote: boolean;
    equipFieldData: EquipFieldData;
    hasExtraData: boolean;
}
